module.exports = __webpack_public_path__ + "media/images/workplace/patterns/9-1194ab993e897206115229f8824d8417.png";